export const PRODUCT_TYPE = 'HX';
export const COMPANY_TAG = 'HRX';
